import {
    DELIVERY_OPTION_DISABLED,
    DELIVERY_OPTION_SELECTED_WITH_SAVINGS,
    DELIVERY_OPTION_SELECTED_WITHOUT_SAVINGS,
    DELIVERY_OPTION_UNSELECTED_WITH_SAVINGS,
    DELIVERY_OPTION_UNSELECTED_WITHOUT_SAVINGS,
    OPTIN_TEXT_SELECTED,
    OPTIN_TEXT_UNSELECTED,
} from "@cart-ui/constants/DeliverySpeed";
import { DELIVERY_SPEED, DELIVERY_SPEED_STRATEGY, DeliverySpeedDetail, Option } from "@swiggy-private/cart-types";
import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types";
import { format, isEmpty } from "@swiggy-private/js-utils";

export const getOptionStyles = (selected?: boolean, isDisabled?: boolean, highlightColor?: string) => {
    if (selected) {
        if (!isEmpty(highlightColor)) {
            return {
                headingVariant: "V2.body2.neutral.bold" as keyof ITypography,
                headingColor: highlightColor as keyof IColors,
                subHeadingVariant: "V2.body3.neutral.regular" as keyof ITypography,
                subHeadingColor: "text_Low_Emphasis" as keyof IColors,
                slaVariant: "V2.body3.neutral.bold" as keyof ITypography,
                slaColor: highlightColor as keyof IColors,
            };
        }
        return {
            headingVariant: "V2.body2.neutral.bold" as keyof ITypography,
            headingColor: "text_Button_Secondary" as keyof IColors,
            subHeadingVariant: "V2.body3.neutral.regular" as keyof ITypography,
            subHeadingColor: "text_Low_Emphasis" as keyof IColors,
            slaVariant: "V2.body3.neutral.bold" as keyof ITypography,
            slaColor: "text_Button_Secondary" as keyof IColors,
        };
    } else {
        if (isDisabled) {
            return {
                headingVariant: "V2.body2.neutral.medium" as keyof ITypography,
                headingColor: "text_disabled" as keyof IColors,
                subHeadingVariant: "V2.body3.neutral.regular" as keyof ITypography,
                subHeadingColor: "text_disabled" as keyof IColors,
                slaVariant: "V2.body3.neutral.medium" as keyof ITypography,
                slaColor: "text_disabled" as keyof IColors,
            };
        }
        return {
            headingVariant: "V2.body2.neutral.medium" as keyof ITypography,
            headingColor: "text_High_Emphasis" as keyof IColors,
            subHeadingVariant: "V2.body3.neutral.regular" as keyof ITypography,
            subHeadingColor: "text_Low_Emphasis" as keyof IColors,
            slaVariant: "V2.body3.neutral.medium" as keyof ITypography,
            slaColor: "text_High_Emphasis" as keyof IColors,
        };
    }
};

export const getDeliveryOptionA11yLabel = ({
    option,
    sla,
    selected,
    savings,
    isDisabled,
    disabledText,
}: {
    selected?: boolean;
    option?: string;
    isDisabled?: boolean;
    sla?: string;
    savings?: string;
    disabledText?: string;
}) => {
    if (isDisabled) {
        return format(DELIVERY_OPTION_DISABLED, option, disabledText);
    }

    if (!isEmpty(savings)) {
        return selected
            ? format(DELIVERY_OPTION_SELECTED_WITH_SAVINGS, option, sla, savings)
            : format(DELIVERY_OPTION_UNSELECTED_WITH_SAVINGS, option, sla, savings);
    }

    return selected
        ? format(DELIVERY_OPTION_SELECTED_WITHOUT_SAVINGS, option, sla)
        : format(DELIVERY_OPTION_UNSELECTED_WITHOUT_SAVINGS, option, sla);
};

export const getOptinAriaLabel = (isOptedIn?: boolean, optInText?: string) => {
    return isOptedIn ? format(OPTIN_TEXT_SELECTED, optInText) : format(OPTIN_TEXT_UNSELECTED, optInText);
};

export function getShowBanner(slaData?: DeliverySpeedDetail, bannerText?: string) {
    return (
        !isEmpty(slaData) &&
        slaData?.type === DELIVERY_SPEED.EXPRESS &&
        slaData.strategy === DELIVERY_SPEED_STRATEGY.VISIBLE &&
        !isEmpty(bannerText)
    );
}

export function getDlsColorForExpressIcon({
    selected,
    disabled,
    highlightColor,
}: {
    selected?: boolean;
    disabled?: boolean;
    highlightColor?: string;
}) {
    let dlsColor: keyof IColors = "text_High_Emphasis";

    if (disabled) {
        dlsColor = "text_disabled";
    } else if (selected) {
        dlsColor = "primary";

        if (!isEmpty(highlightColor)) {
            dlsColor = highlightColor as keyof IColors;
        }
    }

    return dlsColor;
}

export const computeShouldRenderDeliveryOptionBanner = (item: Option) => {
    return !isEmpty(item.deliverySpeedOnlyPresentation) && !isEmpty(item.deliverySpeedOnlyPresentationIcon);
};
